
import styled from "styled-components"
import PageTopTitle from "../../components/shared/PageTopTitle"
import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { getAdminUyeler, getTopluUyeExcel } from "../../features/admin2/admin2Slice"
import { useSelector } from "react-redux"
import Btn from "../../components/shared/button/Btn"
import { showModal } from "../../features/modal/modalSlice"
import SmallSpinner from "../../components/shared/spinners/SmallSpinner"
import Pagination from "../../components/shared/Pagination"
import { useState } from "react"
import InputText from "../../components/shared/input/new/InputText"
import InputSelect from "../../components/shared/input/new/InputSelect"
import UyelerTable from "../../components/shared/adminUyelerAraclar/MobilUyelerTable"
import locationData from "../../utils/locationData/locationOptions"
import InputCityTown from "../../components/shared/input/new/InputCityTown"

const Container = styled.div`
    width: 100%;
    height: auto;

    .wrapper{
        width: 100%;
        padding: 30px;
        min-height: 500px;

        .top-container{
            width: 100%;
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;
            gap: 20px;
            flex-direction: column;
            .filter-container{
                display: flex;
                gap: 20px;
            }

            .btn-container{
                display: flex;
                justify-content: space-between;

                .btn-grp{
                    display: flex;
                    gap: 20px;
                }
            }
            

        }

        .content{
            display: flex;
            flex-direction: column;
            align-items: center;






            .titles{
                width: 100%;
                display: grid;
                grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
                gap: 15px;
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
                text-align: center;
            }
        }
    }
    
`

const versionOptions = [
    {
        id:0,
        text:"Hepsini Getir" 
    },
    {
        id:1,
        text:"Güncellenenleri Getir"
    },
    {
        id:2,
        text:"Güncellenmeyenleri Getir" 
    },
]

const AdminMobilUyeler = () => {

    const dispatch = useDispatch()
    const { isLoadingGetAdminUyeler, adminUyeler, isLoadingGetTopluUyeExcel, adminUyelerCount } = useSelector(state => state.admin2)

    const [itemsPerPage, setItemsPerPage] = useState(20)
    const totalPages = Math.ceil(adminUyelerCount / (itemsPerPage < 1 ? 20 : itemsPerPage));

    const [currentPage, setCurrentPage] = useState(1);

    const [adSoyadUnvan, setAdSoyadUnvan] = useState("")
    const [eyurtNumber, setEyurtNumber] = useState("")
    const [firmaAdi, setFirmaAdi] = useState("")
    const [tcNo, setTcNo] = useState("")
    const [location, setLocation] = useState("")
    const [phoneNumber, setPhoneNumber] = useState("")
    const [appVersionType, setAppVersionType] = useState({
        id:0,
        text:"Hepsini Getir" 
    })

    useEffect(() => {
        dispatch(getAdminUyeler({currentPage, adSoyadUnvan, IlIlce: location?.location, tcNo, phoneNumber: phoneNumber?.trim()?.replace(/^0+/, ''), appVersionType: appVersionType.id, itemsPerPage: itemsPerPage < 1 ? 20 : itemsPerPage }))
    },[currentPage, adSoyadUnvan, eyurtNumber, tcNo, phoneNumber,location?.location, appVersionType.id, itemsPerPage])

    const handleClearAllInput = () => {
        setAdSoyadUnvan("")
        setEyurtNumber("")
        setTcNo("")
        setPhoneNumber("")
        setLocation("")
        setAppVersionType({
            id:0,
            text:"Hepsini Getir" 
        })
}

useEffect(() => {
    setCurrentPage(1)
  },[adSoyadUnvan, location, tcNo, phoneNumber, appVersionType, itemsPerPage])

const handleItemsperPage = (e) => {

    const value = e?.target?.value.replace(/[^0-9]/g, '') 
    setCurrentPage(1)
    setItemsPerPage(value)
}

    //! 0 hepsi
    //! 1 güncelleyenler
    //! 2 güncellemeyenler

  return (
    <Container>
        <PageTopTitle title={"Mobil Üyeler"}/>
        <div className="wrapper">
            <div className="top-container">
                <div className="filter-container">
                    <InputText data={phoneNumber} setData={(e)=> setPhoneNumber(e.target.value)} labelText="Telefon" inputWidth={"140px"} name={"phoneNumber"}/>
                    <InputText data={adSoyadUnvan} setData={(e)=> setAdSoyadUnvan(e.target.value)} labelText="Ad Soyad/Unvan" inputWidth={"160px"} name={"adSoyadUnvan"}/>
                    <InputText data={tcNo} setData={(e)=> setTcNo(e.target.value)} labelText="TC No" inputWidth={"140px"} name={"tcNo"}/>
                    <InputText data={firmaAdi} setData={(e)=> setFirmaAdi(e.target.value)} labelText="Firma Adı" inputWidth={"160px"} name={"firmaAdi"}/>
                    <InputCityTown data={location?.location || ""} setData={setLocation} initialOptions={locationData} labelText={"İlçe / İl"} inputWidth={"220px"} name={"ililce"}/>
                    <InputSelect data={appVersionType.text} setData={setAppVersionType} initialOptions={versionOptions} labelText={"Güncelleme Durumu"} inputWidth={"220px"} name={"appVersionType"}/>
                    <InputText data={itemsPerPage} setData={(e) => handleItemsperPage(e)} labelText="Sayfa başı üye" inputWidth={"160px"}/>
                    <Btn bgColor="transparent" borderColor="#E85446" color="#E85446" width={"140px"} handleClick={handleClearAllInput}>{"Temizle"}</Btn>
                </div>
                <div className="btn-container">
                    <div className="btn-grp">
                        <Btn bgColor="transparent" borderColor="#E85446" color="#E85446" width={"140px"} handleClick={() => dispatch(getTopluUyeExcel())}>{isLoadingGetTopluUyeExcel ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Excel Çıktısı Al"}</Btn>
                        <Btn bgColor="transparent" borderColor="#E85446" color="#E85446" width={"140px"} handleClick={() => dispatch(showModal("adminUyeEkle"))}>Üye Ekle</Btn>
                        <Btn bgColor="transparent" borderColor="#E85446" color="#E85446" width={"140px"} handleClick={() => dispatch(showModal("adminTopluUyeEkle"))}>Toplu Üye Ekle</Btn>
                    </div>
                </div>
            </div>

            <div className="content">

                {
                    isLoadingGetAdminUyeler ? 
                    <SmallSpinner size={"40px"} color={"#fff"}/>
                    :
                    <>
                        <UyelerTable list={adminUyeler}/>
                        <Pagination totalPages={totalPages} handleClick={setCurrentPage} currentPage={currentPage}/>
                    </>
                }

            </div>
        </div>
    </Container>
  )
}


export default AdminMobilUyeler